export default __webpack_public_path__ + "static/media/msp-icon.d3b9744c.svg";